import { Content, ProjectDetailsContainer, ProjectFinalCta } from './styles';
import DynamicZones from '../DynamicZones';
import { ProjectProjectsDynamicDynamicZone, Technology, Testimony } from '../../../types/schema';
import Typography from '../../ui/Typography';
import { useRouter } from 'next/router';
import SectionTextButtons from '../../ui/SectionTextButtons';

export type ProjectPageTemplateProps = {
  projectsDynamic: ProjectProjectsDynamicDynamicZone[];
  technologies?: Technology[];
  testimonies?: Testimony[];
  image: string;
  title: string;
};

const ProjectPageTemplate: React.FC<ProjectPageTemplateProps> = ({
  projectsDynamic,
  image,
  title,
  technologies,
  testimonies,
}) => {
  const router = useRouter();
  const language = router.locale;
  const isEn = language === 'en';
  const projectFinalCta = {
    text: isEn
      ? `<h2>Want to build a project like this?</h2><p>We help companies turn product ideas into web, mobile and AI solutions with a senior team, weekly deliveries and direct communication.</p>`
      : `<h2>Quer tirar um projeto como esse do papel?</h2><p>Ajudamos empresas a transformar ideias em produtos web, mobile e agentes de IA com um time sênior, entregas semanais e comunicação direta.</p>`,
    buttons: [
      {
        title: isEn ? 'Schedule a meeting' : 'Agendar reunião',
        action: isEn
          ? 'https://www.appmasters.io/en/priority-meeting-schedule'
          : 'https://www.appmasters.io/pt/agendar-reuniao-prioritaria',
        type: 'primary',
      },
    ],
    buttonsAlignment: 'left' as const,
    backgroundColor: 'lightGradient',
  };

  return (
    <Content>
      <div className="image">
        <img srcSet={image} alt={title} />
      </div>
      <ProjectDetailsContainer>
        <Typography marginLeft="-1px" variant="h1">
          {title}
        </Typography>
      </ProjectDetailsContainer>
      <DynamicZones
        contentStyle={{ paddingTop: 0, paddingBottom: 10 }}
        dynamicZones={projectsDynamic}
        allTechnologies={technologies}
        allTestimonies={testimonies}
        language={language}
        techsInsideContainer
      />
      <ProjectFinalCta>
        <SectionTextButtons {...projectFinalCta} />
      </ProjectFinalCta>
    </Content>
  );
};

export default ProjectPageTemplate;
